import { createTheme } from "@mui/material/styles";

// https://mui.com/material-ui/customization/color/

const temaOscuro = createTheme({
    typography: {
        fontFamily: '"Be Vietnam Pro", "Work Sans", sans-serif',
        h1: { fontFamily: '"Vollkorn", serif' },
        h2: { fontFamily: '"Vollkorn", serif' },
        h3: { fontFamily: '"Vollkorn", serif' },
        h4: { fontFamily: '"Vollkorn", serif' },
        h5: { fontFamily: '"Vollkorn", serif' },
        h6: { fontFamily: '"Vollkorn", serif' },
    },
    palette: {
        mode: 'dark',
        primary: {
            main: '#FDB813', // Primary
        },
        secondary: {
            main: '#1A1714', // Secondary
            light: '#3e3a35',
        },
        tertiary: {
            main: '#2A2622', // Tertiary
        },
        alert: {
            main: '#ff6b6b',
        },
        background: {
            default: '#121212', // Fondo oscuro
            paper: '#1A1714', // Fondo de elementos como tarjetas
            overPaper: '#2A2622', // Un tono intermedio
        },
        text: {
            primary: '#E5E1DA', // Neutral light text
            secondary: '#b0b0b0',
            disabled: '#757575',
        },
        inputs:{
            active: '#E5E1DA',
            disabled: '#676767'
        },
        divider: '#383838', // Color para separadores o bordes
    },
    breakpoints: {
        values: {
            laptop: 1024,
            tablet: 640,
            mobile: 0,
            desktop: 1280,
        },
    }
});

export default temaOscuro;